import { render, staticRenderFns } from "./ApprovalDutiesPage.vue?vue&type=template&id=8c1206b4"
import script from "./ApprovalDutiesPage.vue?vue&type=script&lang=js"
export * from "./ApprovalDutiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports